import API from "@/models/API";

export default class Collaborators {
    constructor(item = {}) {
        this.store_id = item.store_id || null;
        this.name = item.name || "";
        this.logo = item.logo || null;
        this.from_to_points_ratio = 1;
        this.to_from_points_ratio = 1;
        this.to_company_id = item.to_company_id || null;
    }

    static get = async (query,filters) =>
    API.get(
        `/companies/${localStorage.getItem("storeId")}/synergies${query + filters}`
    );
        
    static create = async data =>
    API.post(
        `/companies/${localStorage.getItem("storeId")}/synergies`,
        data
    );

    static getAvailable = async () =>
    API.get(
        `/companies/${localStorage.getItem("storeId")}/synergies/available-companies`
    );

    static doAction = async data =>
    API.put(
        `/companies/${localStorage.getItem("storeId")}/synergies/${data.synergy_id}/${data.action}`
    );
}
